import { Modal, Button, Input } from "antd";
import { useState } from "react";

const SurveyEmailVerifyModal = ({ open, setOpen, onVerify }) => {
  const [email, setEmail] = useState("");

  const handleVerify = () => {
    onVerify(email);
  };

  return (
    <Modal
      title="Verify Email"
      open={open}
      onCancel={() => setOpen(false)}
      className="clientEscalationModal"
      footer={[
        <div key="footer" className="modalBtns">
          <Button
            className="defaultBtn defaultGreyBtn"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>

          <Button
            className="defaultBtn"
            onClick={handleVerify}
            disabled={!email}
          >
            Verify
          </Button>
        </div>,
      ]}
    >
      <div className="pb-16">
        <p>Please enter your email address to access the survey.</p>

        <Input
          className="pb-16"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default SurveyEmailVerifyModal;
